module.exports = __webpack_public_path__ + "img/checkbox.b761e536.svg";